export * from './lib/pdf-viewer.module';
